<!--
 * @Description: 用户持有银行卡信息操作组件，换卡 由index.js 配置引入
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-24 14:46:45
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div>
        <comp-title-dc back-url-name="bankmanager">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/bankmanager' }">银行卡管理</el-breadcrumb-item>
                <el-breadcrumb-item>换卡</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-change-card">
            <div class="header-title">更换银行卡</div>
            <div class="nav-tip-contain">
                <div class="nav-tip-content">
                    <img src="../../assets/img/change-card-1.svg" alt="" />
                    <div class="margin-11 color-e60012">提交申请</div>
                    <div
                        :class="
                            'background-color-e60012 ' +
                            (acctInfo.needFile == 1 ? 'width-240' : 'width-550')
                        "
                    ></div>
                </div>
                <div v-if="acctInfo.needFile == 1" class="nav-tip-content">
                    <img
                        v-if="navNum > 1"
                        src="../../assets/img/change-card-2-1.svg"
                        alt=""
                        class="margin-l-11"
                    />
                    <img
                        v-else
                        src="../../assets/img/change-card-2-2.svg"
                        alt=""
                        class="margin-l-11"
                    />
                    <div :class="'margin-11 ' + (navNum > 1 ? 'color-e60012' : '')">上传资料</div>
                    <div
                        :class="
                            'width-240 ' +
                            (navNum > 1 ? ' background-color-e60012' : ' background-color-cccccc')
                        "
                    ></div>
                </div>
                <div class="nav-tip-content">
                    <img
                        v-if="navNum > 2"
                        src="../../assets/img/change-card-3-1.svg"
                        alt=""
                        class="margin-l-11"
                    />
                    <img
                        v-else
                        src="../../assets/img/change-card-3-2.svg"
                        alt=""
                        class="margin-l-11"
                    />
                    <div :class="'margin-11 ' + (navNum > 2 ? 'color-e60012' : '')">申请结果</div>
                </div>
            </div>
            <div v-if="navNum == 1" class="bank-info-contain">
                <el-row class="row-common">
                    <el-col :span="9" class="text-align-right">银行名称：</el-col>
                    <el-col :span="15" class="font-size-16">
                        {{ $cache.getDict("110080", acctInfo.bankcode) }}
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="9" class="text-align-right">银行卡号：</el-col>
                    <el-col :span="15" class="font-size-16">
                        {{ acctInfo.depositcard }}
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="9" class="text-align-right">新银行卡号：</el-col>
                    <el-col :span="15" class="font-size-16">
                        <el-input
                            v-model.trim="changCardInfo.newBankCard"
                            :maxlength="20"
                            :placeholder="
                                '请输入' +
                                $cache.getDict('110080', acctInfo.bankcode) +
                                '下的银行卡号'
                            "
                        />
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="9" class="text-align-right">开户行所在省：</el-col>
                    <el-col :span="15" class="font-size-16">
                        <el-select
                            v-model="changCardInfo.province"
                            filterable
                            placeholder="请选择开户行所在省"
                        >
                            <el-option
                                v-for="item in province"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-col>
                </el-row>
                <el-row v-if="changCardInfo.province" class="row-common">
                    <el-col :span="9" class="text-align-right">开户行所在城市：</el-col>
                    <el-col :span="15" class="font-size-16">
                        <el-select
                            v-model="changCardInfo.city"
                            filterable
                            placeholder="请选择开户行所在城市"
                        >
                            <el-option
                                v-for="item in city"
                                :key="item.cityid"
                                :label="item.cityname"
                                :value="item.cityid"
                            />
                        </el-select>
                    </el-col>
                </el-row>

                <el-row
                    v-if="changCardInfo.city !== ''"
                    class="row-common"
                    style="position: relative"
                >
                    <el-col :span="9" class="text-align-right">开户行名称：</el-col>
                    <el-col :span="15" class="font-size-16">
                        <el-autocomplete
                            v-if="inputMode === 1"
                            ref="autocomplete"
                            v-model.trim="changCardInfo.newBankName"
                            class="inline-input"
                            :fetch-suggestions="querySearch"
                            popper-class="auto-width-select-option"
                            placeholder="请选择开户行"
                            :maxlength="40"
                            v-on:blur="checkBankName"
                            v-on:focus="clearOption"
                        ></el-autocomplete>
                        <el-input
                            v-if="inputMode === 2"
                            v-model.trim="changCardInfo.newBankName"
                            placeholder="请输入开户行名称"
                            :maxlength="40"
                        />
                        <div class="append-info">
                            <span v-if="inputMode === 1">
                                未找到？
                                <a v-on:click="changeInputMode(2)">手动输入</a>
                            </span>
                            <span v-if="inputMode === 2">
                                <a v-on:click="changeInputMode(1)">返回</a>
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="9" class="text-align-right">银行户名：</el-col>
                    <el-col :span="15" class="font-size-16">
                        {{ $cache.getUser().custname }}
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="9" class="text-align-right">证件类型：</el-col>
                    <el-col :span="15" class="font-size-16">
                        {{ $cache.getDict("130007", $cache.getUser().certificatetype) }}
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="9" class="text-align-right">证件号码：</el-col>
                    <el-col :span="15" class="font-size-16">
                        {{ $cache.getUser().certificateno }}
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="9" class="text-align-right">联系电话：</el-col>
                    <el-col :span="15" class="font-size-16">
                        <el-input
                            v-model.trim="changCardInfo.mobileno"
                            placeholder="请输入联系电话"
                            :maxlength="11"
                        />
                    </el-col>
                </el-row>
                <el-row class="row-common">
                    <el-col :span="9" class="text-align-right">变更原因：</el-col>
                    <el-col :span="15" class="font-size-16">
                        <el-input
                            v-model.trim="changCardInfo.specification"
                            placeholder="请输入变更原因"
                        />
                    </el-col>
                </el-row>
                <el-row v-if="isPwdCheck" class="row-common">
                    <el-col :span="9" class="text-align-right">交易密码：</el-col>
                    <el-col :span="8" class="font-size-16">
                        <el-input
                            v-model.trim="changCardInfo.pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                        />
                    </el-col>
                    <el-col :span="2">
                        <span
                            class="redemp-btn margin-l-11"
                            v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                        >
                            <span class="like-a">忘记密码？</span>
                        </span>
                    </el-col>
                </el-row>
                <div class="checkbox-contain">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <span class="agree-text">同意</span>
                    <span class="agree-content">
                        免责声明：本人确认申请变更此账户关联的银行卡号，保证申请信息和材料的真实、准确和完整，本人授权基金管理人自行或通过客户身份认证机构对本人提供的身份信息、账户信息等进行验证并自愿承担由此产生的一切风险和后果。
                    </span>
                </div>
                <div class="btn-contain">
                    <button class="cancel-btn" v-on:click="backBank">取消</button>
                    <button
                        :disabled="btnDisabled"
                        :class="
                            'confirm-btn ' +
                            (!btnDisabled ? 'confirm-btn-active' : 'confirm-btn-disabled')
                        "
                        v-on:click="toUpImgInfo"
                    >
                        下一步
                    </button>
                </div>
            </div>
            <div v-if="navNum == 2" class="img-info-contain">
                <div class="img-info-header">
                    <div class="img-info-header1">请上传换卡申请所需的资料</div>
                    <div class="img-info-header2">
                        注意：每个图片大小不能超过{{
                            $cache.getOcrFileSize()
                        }}M，格式类型只支持jpg、jpeg、png，请确保上传图片清晰、边缘完整、避免反光，所有证件必须是原件。
                    </div>
                </div>
                <div class="img-info-content">
                    <div>
                        <div>
                            （1）请上传{{
                                $cache.getDict("130007", $cache.getUser().certificatetype)
                            }}正反面照片
                        </div>
                        <div class="upload-img-box">
                            <div class="upload-img-content">
                                <el-upload
                                    :action="$util.fileUploadPath('/sale-mid/file/upload')"
                                    :data="$util.fileUploadParam('10')"
                                    :headers="$util.fileUploadHeader()"
                                    :before-upload="(file, index) => uploadBefore(file, 0)"
                                    :on-error="uploadError"
                                    :on-success="
                                        (response, file, fileList) =>
                                            uploadSuccess(response, file, fileList, 0)
                                    "
                                    :show-file-list="false"
                                    class="upload-img-info border-dashed"
                                >
                                    <img
                                        v-if="imgInfoArr[0]"
                                        :src="imgInfoShowArr[0]"
                                        alt=""
                                        class="upload-img"
                                    />
                                    <img
                                        v-else
                                        src="../../assets/img/upload-img-id-people.svg"
                                        alt=""
                                    />
                                </el-upload>
                                <div class="width-280 text-align-center margin-l-16">
                                    上传{{
                                        $cache.getDict("130007", $cache.getUser().certificatetype)
                                    }}人像面
                                </div>
                            </div>
                            <div class="upload-img-content">
                                <el-upload
                                    :action="$util.fileUploadPath('/sale-mid/file/upload')"
                                    :data="$util.fileUploadParam('10')"
                                    :headers="$util.fileUploadHeader()"
                                    :before-upload="(file, index) => uploadBefore(file, 1)"
                                    :on-error="uploadError"
                                    :on-success="
                                        (response, file, fileList) =>
                                            uploadSuccess(response, file, fileList, 1)
                                    "
                                    :show-file-list="false"
                                    class="upload-img-info border-dashed"
                                >
                                    <img
                                        v-if="imgInfoArr[1]"
                                        :src="imgInfoShowArr[1]"
                                        alt=""
                                        class="upload-img"
                                    />
                                    <img
                                        v-else
                                        src="../../assets/img/upload-img-id-emblem.svg"
                                        alt=""
                                    />
                                </el-upload>
                                <div class="width-280 text-align-center margin-l-16">
                                    上传{{
                                        $cache.getDict("130007", $cache.getUser().certificatetype)
                                    }}国徽面
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="margin-t-58">
                        <div>（2）请上传同一家银行的新卡照片</div>
                        <div class="upload-img-content">
                            <el-upload
                                :action="$util.fileUploadPath('/sale-mid/file/upload')"
                                :data="$util.fileUploadParam('10')"
                                :headers="$util.fileUploadHeader()"
                                :before-upload="(file, index) => uploadBefore(file, 2)"
                                :on-error="uploadError"
                                :on-success="
                                    (response, file, fileList) =>
                                        uploadSuccess(response, file, fileList, 2)
                                "
                                :show-file-list="false"
                                class="upload-img-info border-dashed"
                            >
                                <img
                                    v-if="imgInfoArr[2]"
                                    :src="imgInfoShowArr[2]"
                                    alt=""
                                    class="upload-img"
                                />
                                <img v-else src="../../assets/img/upload-img-null.svg" alt="" />
                            </el-upload>
                            <div class="width-280 text-align-center margin-l-16">
                                上传新银行卡（借记卡）照片
                            </div>
                        </div>
                    </div>
                    <div class="margin-t-58">
                        <div>
                            （3）请上传银行凭证原件照片(如有其它，可在第五项中继续上传)
                            <span class="require-span">
                                要求：需包含姓名、{{
                                    $cache.getDict("130007", $cache.getUser().certificatetype)
                                }}号码、新旧卡号和旧卡注销状态，盖银行业务章
                            </span>
                        </div>
                        <div class="upload-img-content">
                            <el-upload
                                :action="$util.fileUploadPath('/sale-mid/file/upload')"
                                :data="$util.fileUploadParam('10')"
                                :headers="$util.fileUploadHeader()"
                                :before-upload="(file, index) => uploadBefore(file, 3)"
                                :on-error="uploadError"
                                :on-success="
                                    (response, file, fileList) =>
                                        uploadSuccess(response, file, fileList, 3)
                                "
                                :show-file-list="false"
                                class="upload-img-info border-solid"
                            >
                                <img
                                    v-if="imgInfoArr[3]"
                                    :src="imgInfoShowArr[3]"
                                    alt=""
                                    class="upload-img"
                                />
                                <img v-else src="../../assets/img/upload-img-null.svg" alt="" />
                            </el-upload>
                            <div class="width-280 text-align-center margin-l-16">
                                上传新卡凭证原件
                            </div>
                        </div>
                    </div>
                    <div class="margin-t-58">
                        <div>
                            （4）请上传客户本人手持{{
                                $cache.getDict("130007", $cache.getUser().certificatetype)
                            }}+银行卡的照片
                            <span class="require-span">
                                要求：1、五官清晰可见；2、证件号码和银行卡号页面全部信息需清晰无遮挡；3、露出双手手臂
                            </span>
                        </div>
                        <div class="upload-img-content">
                            <el-upload
                                :action="$util.fileUploadPath('/sale-mid/file/upload')"
                                :data="$util.fileUploadParam('10')"
                                :headers="$util.fileUploadHeader()"
                                :before-upload="(file, index) => uploadBefore(file, 4)"
                                :on-error="uploadError"
                                :on-success="
                                    (response, file, fileList) =>
                                        uploadSuccess(response, file, fileList, 4)
                                "
                                :show-file-list="false"
                                class="upload-img-info border-solid"
                            >
                                <img
                                    v-if="imgInfoArr[4]"
                                    :src="imgInfoShowArr[4]"
                                    alt=""
                                    class="upload-img"
                                />
                                <img v-else src="../../assets/img/upload-img-null.svg" alt="" />
                            </el-upload>
                            <div class="width-280 text-align-center margin-l-16">
                                上传客户手持{{
                                    $cache.getDict("130007", $cache.getUser().certificatetype)
                                }}＋银行卡照片
                            </div>
                        </div>
                    </div>
                    <div class="margin-t-58">
                        <div>
                            （5）其他图片资料
                            <span class="color-999999">(选填)</span>
                        </div>
                        <div class="upload-img-content">
                            <el-upload
                                :action="$util.fileUploadPath('/sale-mid/file/upload')"
                                :data="$util.fileUploadParam('10')"
                                :headers="$util.fileUploadHeader()"
                                :before-upload="(file, index) => uploadBefore(file, 5)"
                                :on-error="uploadError"
                                :on-success="
                                    (response, file, fileList) =>
                                        uploadSuccess(response, file, fileList, 5)
                                "
                                :show-file-list="false"
                                class="upload-img-info border-solid"
                            >
                                <img
                                    v-if="imgInfoArr[5]"
                                    :src="imgInfoShowArr[5]"
                                    alt=""
                                    class="upload-img"
                                />
                                <img v-else src="../../assets/img/upload-img-null.svg" alt="" />
                            </el-upload>
                            <div class="width-280 text-align-center margin-l-16">上传图片</div>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <button
                        :disabled="submitBtnDisabled"
                        :class="
                            'btn-submit ' +
                            (!submitBtnDisabled ? 'btn-submit-active' : 'btn-submit-disabled')
                        "
                        v-on:click="toSubmitInfo"
                    >
                        提交
                    </button>
                </div>
            </div>
            <div v-if="navNum == 3" class="bank-info-contain">
                <div>
                    <div class="res-box">
                        <div class="res-img">
                            <img src="../../assets/img/buy_success.png" alt="" />
                        </div>
                        <div class="res-text">更换银行卡申请成功！</div>
                    </div>
                    <div class="btn-confirm-box">
                        <button class="btn-confirm" v-on:click="backBank">确定</button>
                    </div>
                </div>
            </div>
        </div>
        <mobile-code
            :mobile-visible="mobileVisible"
            :mobile-no="changCardInfo.mobileno"
            v-on:verify-in="getMobileCode"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import mobileCode from "@/components/layout/mobileCodeDc.vue";
import userApi from "@/api/user";

export default {
    name: "AddBank",
    components: { mobileCode },
    mixins: [mixin],
    data() {
        return {
            navNum: 1,
            checked: false,
            changCardInfo: {
                newBankCard: "",
                province: "",
                city: "",
                newBankName: "",
                specification: "",
                pwd: "",
                mobileno: ""
            },
            checkFlag: false,
            isPwdCheck: true,
            acctInfo: {},
            imgInfoArr: ["", "", "", "", "", ""],
            imgInfoShowArr: ["", "", "", "", "", ""],
            mobileVisible: false,
            randomToken: "",
            province: [], // 省
            city: [], // 城市
            oldBankInfo: {},
            inputMode: 1 // 1-下拉选项  2-手动输入
        };
    },
    computed: {
        btnDisabled() {
            if (
                !this.checkFlag ||
                !this.checked ||
                !this.changCardInfo.newBankCard ||
                !this.changCardInfo.newBankName ||
                !this.changCardInfo.specification ||
                (this.isPwdCheck && this.changCardInfo.pwd.trim() == "")
            ) {
                return true;
            } else {
                return false;
            }
        },
        submitBtnDisabled() {
            let finishAllImgs = true;
            this.imgInfoArr.forEach((item, index) => {
                if (!item && index != 5) {
                    finishAllImgs = false;
                }
            });
            return !finishAllImgs;
        }
    },
    watch: {
        "changCardInfo.province"(val) {
            const _this = this;
            // 城市查询
            const _p = _this.province.find((item) => {
                return item.subitem === val;
            });
            this.$util.getCity(_p.subitem, (data) => {
                _this.city = data || [];
                let _cityObj = {};
                let _city = "";
                // 城市查询结果是否存在
                if (_this.city.length > 0) {
                    // 是否存在旧的城市选项
                    if (_this.oldBankInfo.city && _this.oldBankInfo.province === val) {
                        _cityObj = _this.city.find((item) => {
                            return (
                                item.cityname === _this.oldBankInfo.city ||
                                item.cityid === _this.oldBankInfo.city
                            );
                        });
                        _this.oldBankInfo.city = _cityObj.cityid || "";
                    }
                    _city = _cityObj.cityid || _this.city[0].cityid;
                }
                _this.$set(_this.changCardInfo, "city", _city || "");
                _this.$set(_this.changCardInfo, "newBankName", "");
            });
        },
        "changCardInfo.city"(val) {
            this.changCardInfo.newBankName = "";
            this.clearOption();
            if (!val) return;
            if (this.oldBankInfo.city === this.changCardInfo.city && this.oldBankInfo.name) {
                let cityObj = this.city.find((item) => {
                    return item.cityid === this.changCardInfo.city;
                });
                this.changCardInfo.cityName = cityObj.cityname;
                this.$util.querySearch(this, this.oldBankInfo.name, this.acctInfo.bankcode);
                this.$set(
                    this.changCardInfo,
                    "newBankName",
                    this.oldBankInfo.city === this.changCardInfo.city ? this.oldBankInfo.name : ""
                );
            }
        }
    },
    mounted() {
        this.province = this.$cache.getDict("190021");
        // 换卡先不校验，密码输入在上传图片之前，校验在上传图片之后，会导致用户把资料全部填完，密码错误得重新回到资料填写界面填密码
        // this.isPwdCheck = this.$cache.getPwdCheck("0A7");
        this.acctInfo = this.$route.query;
        this.changCardInfo.mobileno = this.acctInfo.mobileno;
    },
    methods: {
        clearOption() {
            if (this.$refs.autocomplete) {
                this.$refs.autocomplete.suggestions = [];
            }
        },
        backBank() {
            this.$router.push({
                name: "bankmanager"
            });
        },
        uploadBefore(file, index) {
            let maxSize = this.$cache.getOcrFileSize();
            if (file.size > 1024 * 1024 * maxSize) {
                this.$message.warning("上传文件大小超过限制大小" + maxSize + "M，不能上传");
                return false;
            }
            this.$set(this.imgInfoShowArr, index, URL.createObjectURL(file));
        },
        uploadError(err, file, fileList) {
            this.$message.warning(err);
        },
        uploadSuccess(response, file, fileList, index) {
            this.$set(this.imgInfoArr, index, response.body.fileCode);
        },
        async toUpImgInfo() {
            if (!this.changCardInfo.mobileno) {
                this.$message.error("请输入手机号码");
                return;
            }
            if (this.changCardInfo.mobileno !== this.acctInfo.mobileno) {
                if (!/^(1)(\d{10})$/.test(this.changCardInfo.mobileno)) {
                    this.$message.error("请输入真实的手机号");
                    return;
                }
            }
            const reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·sa-zA-Z\d]{2,40}$/;
            if (!reg.test(this.changCardInfo.newBankName)) {
                this.$message.error("该开户行不支持！");
                return;
            }
            const bankReg = /^[0-9]{8,20}$/g;
            if (!bankReg.test(this.changCardInfo.newBankCard)) {
                this.$message.error("银行卡号只能为8-20位数字");
                return;
            }
            if (this.$cache.getIsEncrypted()) {
                const verifyRes = await userApi.verifyService({
                    en_depositcard: this.acctInfo.en_desendepositcard,
                    newdepositcard: this.changCardInfo.newBankCard,
                    paychannel: this.acctInfo.paycenterid
                });
                if (this.changCardInfo.mobileno.indexOf("*") > -1) {
                    verifyRes["en_mobileno"] = this.acctInfo.en_mobileno;
                } else {
                    verifyRes["mobileno"] = this.changCardInfo.mobileno;
                }
                if (verifyRes.data.depositcardflag == 1) {
                    this.$message.error("新银行卡号不能和旧银行卡号一样！");
                    return;
                }
            } else {
                if (this.acctInfo.desendepositcard == this.changCardInfo.newBankCard) {
                    this.$message.error("新银行卡号不能和旧银行卡号一样！");
                    return;
                }
            }

            const pwdRes = await userApi.combPasswordCheck({
                tradepassword: this.$util.enc(this.changCardInfo.pwd)
            });
            if (pwdRes.code != 0) {
                return;
            }
            // 柜台换卡
            if (this.acctInfo.needFile == "1") {
                this.navNum = 2;
            } else {
                // 自助换卡
                if (this.acctInfo.identifytype == "0") {
                    this.$message.error("签约或解约方式未配置！");
                } else {
                    if (
                        this.acctInfo.signstatus == "1" &&
                        (this.acctInfo.unsigntype.includes("1") ||
                            this.acctInfo.unsigntype.includes("2"))
                    ) {
                        let isDecryptObj = {};
                        if (this.$cache.getIsEncrypted()) {
                            isDecryptObj.en_depositname = this.$cache.getUser().en_custname;
                            isDecryptObj.en_certificateno = this.$cache.getUser().en_certificateno;
                            isDecryptObj.en_custname = this.$cache.getUser().en_custname;
                            isDecryptObj.en_depositcard = this.acctInfo.en_desendepositcard;
                            if (this.changCardInfo.mobileno.indexOf("*") > -1) {
                                isDecryptObj["en_mobileno"] = this.acctInfo.en_mobileno;
                            } else {
                                isDecryptObj["mobileno"] = this.changCardInfo.mobileno;
                            }
                        } else {
                            isDecryptObj.depositname = this.$cache.getUser().custname;
                            isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                            isDecryptObj.custname = this.$cache.getUser().custname;
                            isDecryptObj.depositcard = this.acctInfo.desendepositcard;
                            isDecryptObj.mobileno = this.changCardInfo.mobileno;
                        }
                        let data = {
                            ...isDecryptObj,
                            certificatetype: this.$cache.getUser().certificatetype,
                            bankcardid: this.acctInfo.bankcardid,
                            bankcode: this.acctInfo.bankcode,
                            paychannel: this.acctInfo.paycenterid,
                            channelid: this.acctInfo.paycenterid + this.acctInfo.bankcode,
                            channelname:
                                this.$cache
                                    .getDict("110079", this.acctInfo.paycenterid)
                                    .toString()
                                    .substr(0, 4) +
                                "-" +
                                this.$cache.getDict("110080", this.acctInfo.bankcode)
                        };
                        this.randomToken = this.$util.generateRandomNumber();
                        data.pagecallbackurl =
                            window.location.origin +
                            "" +
                            "/sale-mid-ump/bank/redirect?token=" +
                            this.randomToken;
                        // 建行网联的回调地址配置在银行那边，需要单独处理
                        if (this.acctInfo.paycenterid == "0105") {
                            data.pagecallbackurl =
                                window.location.origin + "" + "/sale-mid-ump/bank/ccb";
                        }
                        if (this.acctInfo.unsigntype == "1") {
                            // 后台解约
                            const res = await userApi.combUnSignBankHandler(
                                data,
                                this.$cache.getIsEncrypted()
                            );
                            if (res.code == "0") {
                                // 旧卡解约完成，现在做新卡签约
                                this.acctInfo.signstatus = "0";
                                this.newBankCardSign();
                            }
                        } else {
                            // 页面解约
                            data.signtype = 0;
                            const res = await userApi.combUnSignApply(
                                data,
                                this.$cache.getIsEncrypted()
                            );
                            if (res.data) {
                                const pageUrl = res.data.bankgateurl ? res.data.bankgateurl : "";
                                let pageParam = res.data.bankgateparam
                                    ? res.data.bankgateparam
                                    : {};
                                if (pageParam) {
                                    pageParam = JSON.parse(pageParam);
                                }
                                const bankgateserialno = res.data.bankgateserialno;
                                const reqMethod = res.data.method;
                                this.$util.openPostWindow(pageUrl, pageParam, reqMethod, "_blank");
                                const params = {
                                    token: this.randomToken,
                                    certificatetype: this.$cache.getUser().certificatetype,
                                    certificateno: this.$cache.getUser().certificateno,
                                    bankcode: this.acctInfo.bankcode,
                                    depositname: this.$cache.getUser().custname,
                                    paychannel: this.acctInfo.paycenterid,
                                    bankgateserialno: bankgateserialno,
                                    signtype: "0"
                                };
                                if (this.$cache.getIsEncrypted()) {
                                    params.en_depositcard = this.acctInfo.en_desendepositcard;
                                    if (this.changCardInfo.mobileno.indexOf("*") > -1) {
                                        params["en_mobileno"] = this.acctInfo.en_mobileno;
                                    } else {
                                        params["mobileno"] = this.changCardInfo.mobileno;
                                    }
                                } else {
                                    params.depositcard = this.acctInfo.desendepositcard;
                                    params.mobileno = this.changCardInfo.mobileno;
                                }
                                if (this.acctInfo.bankcardid) {
                                    params.bankcardid = this.acctInfo.bankcardid;
                                }
                                // 解约要做的操作
                                this.$util.confirmBankAuth(
                                    this,
                                    params,
                                    "unSignBankPageAuthentication",
                                    () => {
                                        // 旧卡解约成功，去做新卡签约
                                        this.acctInfo.signstatus = "0";
                                        this.newBankCardSign();
                                    }
                                );
                            }
                        }
                    } else {
                        // 旧卡已解约，直接做新卡签约
                        // 或未配置a和8，不校验原卡是否解约
                        this.newBankCardSign();
                    }
                }
            }
        },
        async newBankCardSign() {
            let isDecryptObj = {};
            if (this.$cache.getIsEncrypted()) {
                isDecryptObj.en_depositname = this.$cache.getUser().en_custname;
                isDecryptObj.en_certificateno = this.$cache.getUser().en_certificateno;
                isDecryptObj.en_custname = this.$cache.getUser().en_custname;
                if (this.changCardInfo.mobileno.indexOf("*") > -1) {
                    isDecryptObj["en_mobileno"] = this.acctInfo.en_mobileno;
                } else {
                    isDecryptObj["mobileno"] = this.changCardInfo.mobileno;
                }
            } else {
                isDecryptObj.depositname = this.$cache.getUser().custname;
                isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                isDecryptObj.custname = this.$cache.getUser().custname;
                isDecryptObj.mobileno = this.changCardInfo.mobileno;
            }
            let data = {
                ...isDecryptObj,
                biztype: "02",
                depositcard: this.changCardInfo.newBankCard,
                certificatetype: this.$cache.getUser().certificatetype,
                bankcode: this.acctInfo.bankcode,
                paychannel: this.acctInfo.paycenterid,
                channelid: this.acctInfo.paycenterid + this.acctInfo.bankcode,
                channelname:
                    this.$cache
                        .getDict("110079", this.acctInfo.paycenterid)
                        .toString()
                        .substr(0, 4) +
                    "-" +
                    this.$cache.getDict("110080", this.acctInfo.bankcode)
            };
            this.randomToken = this.$util.generateRandomNumber();
            data.pagecallbackurl =
                window.location.origin +
                "" +
                "/sale-mid-ump/bank/redirect?token=" +
                this.randomToken;
            // 建行网联的回调地址配置在银行那边，需要单独处理
            if (this.acctInfo.paycenterid == "0105") {
                data.pagecallbackurl = window.location.origin + "" + "/sale-mid-ump/bank/ccb";
            }
            if (this.acctInfo.identifytype == "1") {
                // 短信签约
                data.verifytype = "1";
                const res = await userApi.sendBindCardSms(data, this.$cache.getIsEncrypted());
                if (res.data) {
                    this.mobileVisible = true;
                }
            } else {
                // 页面签约
                data.verifytype = "0";
                const res = await userApi.sendBindCardSms(data, this.$cache.getIsEncrypted());
                const pageUrl = res.data.bankgateurl ? res.data.bankgateurl : "";
                let pageParam = res.data.bankgateparam ? res.data.bankgateparam : {};
                if (pageParam) {
                    pageParam = JSON.parse(pageParam);
                }
                const bankgateserialno = res.data.bankgateserialno;
                const reqMethod = res.data.method;
                this.$util.openPostWindow(pageUrl, pageParam, reqMethod, "_blank");
                const params = {
                    token: this.randomToken,
                    certificatetype: this.$cache.getUser().certificatetype,
                    certificateno: this.$cache.getUser().certificateno,
                    bankcode: this.acctInfo.bankcode,
                    depositcard: this.changCardInfo.newBankCard,
                    depositname: this.$cache.getUser().custname,
                    paychannel: this.acctInfo.paycenterid,
                    bankgateserialno: bankgateserialno,
                    signtype: "0"
                };
                if (this.$cache.getIsEncrypted()) {
                    if (this.changCardInfo.mobileno.indexOf("*") > -1) {
                        isDecryptObj["en_mobileno"] = this.acctInfo.en_mobileno;
                    } else {
                        isDecryptObj["mobileno"] = this.changCardInfo.mobileno;
                    }
                } else {
                    params.mobileno = this.changCardInfo.mobileno;
                }
                // 签约要做的操作
                this.$util.confirmBankAuth(this, params, "BankPageAuthentication", async () => {
                    let isDecryptObj = {};
                    if (this.$cache.getIsEncrypted()) {
                        isDecryptObj.en_certificateno = this.$cache.getUser().en_certificateno;
                    } else {
                        isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                    }
                    const res = await userApi.combUpdateBankcardAuth(
                        {
                            ...isDecryptObj,
                            certificatetype: this.$cache.getUser().certificatetype,
                            bankcode: this.acctInfo.bankcode,
                            depositcard: this.changCardInfo.newBankCard,
                            paychannel: this.acctInfo.paycenterid,
                            bankcardid: this.acctInfo.bankcardid
                        },
                        this.$cache.getIsEncrypted()
                    );
                    if (res.code == "0" && res.body) {
                        // 页面签约验证成功现在调自助换卡
                        this.toSubmitAutoInfo();
                    }
                });
            }
        },
        async toSubmitAutoInfo() {
            let branchcode = "";
            // 获取联行号
            const _y = this.branchList.filter((branch) => {
                return branch.branchname === this.changCardInfo.newBankName;
            });
            if (_y && _y[0]) {
                branchcode = _y[0].exchangecode;
            }
            const params = {
                depositcard: this.changCardInfo.newBankCard,
                paychannel: this.acctInfo.paychannel,
                tradepassword: this.$util.enc(this.changCardInfo.pwd),
                authenticateflag: "1",
                bankname: this.changCardInfo.newBankName,
                branchinterbankcode: branchcode,
                transactionaccountid: this.acctInfo.transactionaccountid,
                bankcardid: this.acctInfo.bankcardid,
                specification: this.changCardInfo.specification
            };
            if (this.$cache.getIsEncrypted()) {
                let enMobileno = this.acctInfo.en_mobileno
                    ? this.acctInfo.en_mobileno
                    : this.$cache.getUser().en_mobileno;
                if (this.changCardInfo.mobileno.indexOf("*") > -1) {
                    params["en_mobileno"] = enMobileno;
                } else {
                    params["mobileno"] = this.changCardInfo.mobileno;
                }
                params.en_depositname = this.$cache.getUser().en_custname;
                params.en_depositcardold = this.acctInfo.en_desendepositcard;
            } else {
                params.bankcardmobile = this.acctInfo.mobileno
                    ? this.acctInfo.mobileno
                    : this.$cache.getUser().mobileno;
                params.depositname = this.$cache.getUser().custname;
                params.depositcardold = this.acctInfo.desendepositcard;
            }
            const res = await userApi.combBankCardUpdate(params, this.$cache.getIsEncrypted());
            if (res.data) {
                this.navNum = 3;
            }
        },
        async toSubmitInfo() {
            let branchcode = "";
            // 获取联行号
            const _y = this.branchList.filter((branch) => {
                return branch.branchname === this.changCardInfo.newBankName;
            });
            if (_y && _y[0]) {
                branchcode = _y[0].exchangecode;
            }
            let isDecryptObj = {};
            if (this.$cache.getIsEncrypted()) {
                isDecryptObj.en_custname = this.$cache.getUser().en_custname;
                isDecryptObj.en_certificateno = this.$cache.getUser().en_certificateno;
                isDecryptObj.en_depositname = this.$cache.getUser().en_custname;
                isDecryptObj.en_depositcardold = this.acctInfo.en_desendepositcard;
                if (this.changCardInfo.mobileno.indexOf("*") > -1) {
                    isDecryptObj["en_mobileno"] = this.changCardInfo.mobileno;
                } else {
                    isDecryptObj["mobileno"] = this.changCardInfo.mobileno;
                }
            } else {
                isDecryptObj.custname = this.$cache.getUser().custname;
                isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                isDecryptObj.depositname = this.$cache.getUser().custname;
                isDecryptObj.depositcardold = this.acctInfo.desendepositcard;
                isDecryptObj.mobileno = this.changCardInfo.mobileno;
            }
            const reqParams = {
                ...isDecryptObj,
                invtp: "1",
                certificatetype: this.$cache.getUser().certificatetype,
                validdate:
                    this.$cache.getUser().validdate == "长期有效"
                        ? "99991231"
                        : this.$cache.getUser().validdate,
                depositcardnew: this.changCardInfo.newBankCard,
                bankcode: this.acctInfo.bankcode,
                bankname: this.changCardInfo.newBankName,
                depositprov: this.changCardInfo.province,
                depositcity: this.changCardInfo.city,
                transactionaccountid: this.acctInfo.transactionaccountid,
                changereason: this.changCardInfo.specification,

                branchname: this.changCardInfo.newBankName,
                branchinterbankcode: branchcode,
                paychannel: this.acctInfo.paycenterid
            };

            if (this.acctInfo.needFile == "1") {
                const sysFileattachments = [
                    {
                        filesno: this.imgInfoArr[0],
                        filetype: "881",
                        fileurl: this.imgInfoArr[0],
                        businesscode: "0X1",
                        name:
                            this.$cache.getDict("130007", this.$cache.getUser().certificatetype) +
                            "人像面",
                        fileCode: this.imgInfoArr[0]
                    },
                    {
                        filesno: this.imgInfoArr[1],
                        filetype: "882",
                        fileurl: this.imgInfoArr[1],
                        businesscode: "0X1",
                        name:
                            this.$cache.getDict("130007", this.$cache.getUser().certificatetype) +
                            "国徽面",
                        fileCode: this.imgInfoArr[1]
                    },
                    {
                        filesno: this.imgInfoArr[2],
                        filetype: "883",
                        fileurl: this.imgInfoArr[2],
                        businesscode: "0X1",
                        name: "新银行卡（借记卡）照片",
                        fileCode: this.imgInfoArr[2]
                    },
                    {
                        filesno: this.imgInfoArr[3],
                        filetype: "884",
                        fileurl: this.imgInfoArr[3],
                        businesscode: "0X1",
                        name: "新卡凭证原件",
                        fileCode: this.imgInfoArr[3]
                    },
                    {
                        filesno: this.imgInfoArr[4],
                        filetype: "885",
                        fileurl: this.imgInfoArr[4],
                        businesscode: "0X1",
                        name:
                            "手持" +
                            this.$cache.getDict("130007", this.$cache.getUser().certificatetype) +
                            "+银行卡照片",
                        fileCode: this.imgInfoArr[4]
                    }
                ];
                if (this.imgInfoArr[5] != "") {
                    sysFileattachments.push({
                        filesno: this.imgInfoArr[5],
                        filetype: "886",
                        fileurl: this.imgInfoArr[5],
                        businesscode: "0X1",
                        name: "其他资料照片",
                        fileCode: this.imgInfoArr[5]
                    });
                }
                reqParams.sysFileattachments = sysFileattachments;
            }
            const res = await userApi.appOnlineCardChange(reqParams, this.$cache.getIsEncrypted());
            if (res.code == "0") {
                this.navNum = 3;
            }
        },
        // 生成搜索列表
        querySearch(queryString, cb) {
            this.checkFlag = false;
            this.$util.querySearch(
                this,
                this.changCardInfo.newBankName,
                this.acctInfo.bankcode,
                cb,
                "changCardInfo"
            );
        },
        checkBankName() {
            const _y = this.branchList.filter((branch) => {
                return branch.branchname === this.changCardInfo.newBankName;
            });
            if (_y.length === 0) {
                this.$set(this.changCardInfo, "newBankName", "");
            }
            this.checkFlag = true;
        },
        getMobileCode(val) {
            this.mobileVisible = false;
            if (val) {
                this.checkVerifyCode(val);
            }
            return false;
        },
        /* 校验手机验证码 */
        async checkVerifyCode(val) {
            const params = { biztype: "02", smscode: val };
            const authMobileno = this.changCardInfo.mobileno || "";
            // authReceive 必须沿用本次 authSend 的手机号查询短信缓存，避免输错联系电话时仍按原手机号查缓存。
            if (this.$cache.getIsEncrypted()) {
                if (authMobileno.indexOf("*") > -1) {
                    params.en_mobileno = this.acctInfo.en_mobileno;
                } else {
                    params.mobileno = authMobileno;
                }
            } else {
                params.mobileno = authMobileno;
            }
            const res = await userApi.checkBindCardSms(params, this.$cache.getIsEncrypted());
            if (res.code == "0") {
                let isDecryptObj = {};
                if (this.$cache.getIsEncrypted()) {
                    isDecryptObj.en_certificateno = this.$cache.getUser().en_certificateno;
                } else {
                    isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                }
                const res = await userApi.combUpdateBankcardAuth(
                    {
                        ...isDecryptObj,
                        certificatetype: this.$cache.getUser().certificatetype,
                        bankcode: this.acctInfo.bankcode,
                        depositcard: this.changCardInfo.newBankCard,
                        paychannel: this.acctInfo.paycenterid,
                        bankcardid: this.acctInfo.bankcardid
                    },
                    this.$cache.getIsEncrypted()
                );
                if (res.code == "0" && res.body) {
                    // 短信签约验证成功现在调自助换卡
                    this.toSubmitAutoInfo();
                }
            }
        },
        changeInputMode(mode) {
            this.inputMode = mode;
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-change-card {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding-bottom: 52px;
    .header-title {
        width: 1160px;
        padding: 17px 0 21px 0;
        margin-left: 20px;
        text-align: center;
        border-bottom: 1px solid #f1f1f1;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
    }
    .nav-tip-contain {
        display: flex;
        margin: auto;
        margin-top: 30px;
        margin-left: 187px;
        color: #333333;
        .nav-tip-content {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: normal;
        }
    }
    .bank-info-contain {
        margin-top: 40px;
        font-size: 14px;
        font-weight: normal;
        color: #333333;
        .new-bank-name-contain {
            display: flex;
            align-items: center;
            width: 400px;
            box-sizing: border-box;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            height: 40px;
            .new-bank-name-text {
                width: 99px;
                padding: 15px;
            }
            .bar {
                width: 1px;
                height: 20px;
                background-color: #d9d9d9;
            }
            :deep(.el-input) {
                width: 300px !important;
                border-left: none;
                .el-input__inner {
                    width: 300px !important;
                    border-left: none;
                }
            }
        }
        :deep(.el-input__inner) {
            width: 400px !important;
        }
        .row-common {
            margin-bottom: 20px;
            display: flex;
            align-items: center;
        }
        .checkbox-contain {
            padding: 0 340px;
            font-size: 14px;
            font-weight: normal;
            line-height: 22px;
            .agree-text {
                margin-left: 4px;
                color: #999999;
            }
            .agree-content {
                color: var(--color-primary);
            }
        }
        .btn-contain {
            margin-top: 30px;
            text-align: center;
            .cancel-btn {
                width: 180px;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                background: #e4e4e4;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                color: #666666;
                cursor: pointer;
                border: none;
            }
            .confirm-btn {
                margin-left: 40px;
                width: 180px;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                border: none;
                color: #ffffff;
            }
            .confirm-btn-active {
                background: var(--color-primary);
                cursor: pointer;
            }
            .confirm-btn-disabled {
                background: #f7b2b8;
            }
        }
    }
    .img-info-contain {
        margin: 30px 21px;
        .img-info-header {
            padding: 30px 16px 24px;
            .img-info-header1 {
                font-size: 20px;
                font-weight: 500;
                line-height: 28px;
                color: #333333;
            }
            .img-info-header2 {
                font-size: 16px;
                font-weight: normal;
                line-height: 28px;
                color: var(--color-primary);
                margin-top: 10px;
            }
        }
        .img-info-content {
            margin-top: 38px;
            font-size: 16px;
            font-weight: 500;
            line-height: 23.4px;
            color: #333333;
            .require-span {
                margin-left: 18px;
                color: var(--color-primary);
            }
            .upload-img-box {
                display: flex;
            }
            .upload-img-content {
                font-size: 16px;
                font-weight: normal;
                line-height: 32px;
                color: #999999;
            }
            .upload-img-info {
                width: 280px;
                height: 159px;
                margin: 38px 40px 16px 16px;
                img {
                    height: 159px;
                }
            }
        }
        .btn-box {
            text-align: center;
            .btn-submit {
                width: 180px;
                text-align: center;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
                border: none;
                margin-top: 40px;
            }
            .btn-submit-active {
                background: var(--color-primary);
                cursor: pointer;
            }
            .btn-submit-disabled {
                background: #f7b2b8;
            }
        }
    }
    .res-box {
        margin: auto;
        width: 660px;
        height: 242px;
        border-radius: 6px;
        background: #f9f9f9;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .res-text {
            margin-top: 23.83px;
            font-size: 26px;
            font-weight: 500;
            text-align: center;
            color: #333333;
        }
    }
    .btn-confirm-box {
        text-align: center;
        margin-top: 40px;
        .btn-confirm {
            width: 180px;
            text-align: center;
            height: 42px;
            line-height: 42px;
            border-radius: 2px;
            background: var(--color-primary);
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            border: none;
            cursor: pointer;
        }
    }
    .border-solid {
        border: 1px solid #f1f1f1;
        border-radius: 4.77px;
    }
    .border-dashed {
        border: 1px dashed #f1f1f1;
        border-width: 2px;
        border-radius: 4.77px;
    }
    .color-e60012 {
        color: var(--color-primary);
    }
    .color-999999 {
        color: #999999;
    }
    .margin-11 {
        margin: 0 11px;
    }
    .margin-l-11 {
        margin-left: 11px;
    }
    .margin-l-16 {
        margin-left: 16px;
    }
    .margin-t-58 {
        margin-top: 58px;
    }
    .font-size-16 {
        font-size: 16px;
    }
    .width-240 {
        width: 240px;
        height: 1px;
    }
    .width-550 {
        width: 550px;
        height: 1px;
    }
    .width-280 {
        width: 280px;
    }
    .text-align-center {
        text-align: center;
    }
    .background-color-cccccc {
        background-color: #cccccc;
    }
    .background-color-e60012 {
        background-color: var(--color-primary);
    }
    .text-align-right {
        text-align: right;
    }
    .upload-img {
        width: 280px;
        height: 159px;
    }
    .append-info {
        position: absolute;
        left: 868px;
        top: 8px;
    }
}
</style>
